import { JobSearchJobTypeResponse } from '@doda/api-client/aspida/@types';
import { LinkList } from '../../LinkList';
import { nonNullableText } from '../createLinkList';

/**
 * 職種の関連リンクPropsを生成する
 * @param jobSearchJobTypeResponse
 */
export const createOccupationLinkList = (
  jobSearchJobTypeResponse?: JobSearchJobTypeResponse
): LinkList => ({
  separator: '＞',
  list: [
    {
      text: jobSearchJobTypeResponse?.searchJobTypeLName ?? '',
      href: jobSearchJobTypeResponse?.searchJobTypeLURL ?? '',
    },
    {
      text: jobSearchJobTypeResponse?.searchJobTypeMName ?? '',
      href: jobSearchJobTypeResponse?.searchJobTypeMURL ?? '',
    },
    {
      text: jobSearchJobTypeResponse?.searchJobTypeSName ?? '',
      href: jobSearchJobTypeResponse?.searchJobTypeSURL ?? '',
    },
  ].filter(nonNullableText),
});
